
const Home = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Добро пожаловать в Racing Portal</h1>
      <p>Ваш главный источник информации о гонках и соревнованиях</p>
      <div style={{ marginTop: '2rem' }}>
        <h2>Последние новости</h2>
        <ul>
          <li>Предстоящие соревнования</li>
          <li>Результаты последних гонок</li>
          <li>Анонсы мероприятий</li>
        </ul>
      </div>
    </div>
  )
}

export default Home 